import {setupUploadFilesModal} from '../../common/upload-files-modal';
import {runOnce} from '../../common/run-once';
import {documentReady} from '../../document-ready';

runOnce('helper-upload-files-modal', () => {
    documentReady().then(() => {
        setupUploadFilesModal();
    });
});
